import { createFeatureSelector, createSelector } from '@ngrx/store'
import { EmployeeState } from '../state/employee.state'

const getEmployeeState = createFeatureSelector<EmployeeState>('employee')

export const getEmployeeBankingInfo = () =>
  createSelector(getEmployeeState, state => {
    return state?.bankingInfo
  })
